import { initBlogArticlePage } from "./initBlogArticlePage";
$(document).ready(function () {
     initBlogArticlePage();
     $('#return-blog').click(function () {
          var returnlink = localStorage.getItem('current_context_url');
		if(returnlink === "" || returnlink === null){
               var afterCom =window.location.href.split('.com')[1];
               var isWebSite =  afterCom.split('/')[1].replace(/[^a-zA-Z ]/g, "") === "ca" ? "ca" : "us";
               if (isWebSite == "us"){
                    window.location.replace(`${window.location.origin}/press-center`);
               }
               else{
                    window.location.replace(`${window.location.origin}/${window.location.href.split('/')[3]}/press-center`);
               }
           }
	     else{
           window.location.replace(returnlink);
		 }
          // if(document.referrer === '') {
          //      window.location.replace(`${window.location.origin}/press-center/`);
          //  }
          //  else{
          //      window.location.href = document.referrer;
          //  }
    });
});

$("#a_share_link_blogs").on("click", function (e: any)
{
    e.preventDefault();
    let pageUrl = decodeURIComponent(window.location.href);
    //desc = decodeURIComponent($("#imageGalleryTitle").text());
    let urlImg = pageUrl;
    //socialWindow_lightbox_gallery(urlImg,"link");
    copyToClipboard(urlImg);
});

function copyToClipboard(url: string)
{
    const listener = (e: ClipboardEvent) =>
    {
        e.clipboardData.setData('text/plain', url);
        e.preventDefault();
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    alert(`${url}\n Copied to Clipboard`);
    document.removeEventListener('copy', listener);
}